import { Controller, FieldError, FieldValues, Path } from "react-hook-form";
import { Toggle } from "@songtradr-one/components-frontend";
import { Flex } from "../../../flex/Flex.Parts";
import { FormFieldWrapper } from "../../../form-field-wrapper/FormFieldWrapper";
import { InnerLabel, Label, Props } from "./ToggleField.Parts";

export const ToggleField = <
  FormFields extends FieldValues,
  FieldName extends Path<FormFields>,
>({
  control,
  errors,
  rules,
  label,
  name,
  single,
  disabled,
  size,
}: Props<FormFields, FieldName>) => {
  return (
    <FormFieldWrapper
      $single={single}
      name={name}
      error={errors[name] as FieldError}
    >
      <Controller
        name={name}
        control={control}
        rules={{ ...rules }}
        render={({ field: { onChange, value, name: fieldName } }) => {
          const isChecked = value === true;

          return (
            <Flex $gap={"1rem"} $align="center">
              {label ? (
                <Label>
                  <Toggle
                    checked={isChecked}
                    disabled={disabled}
                    name={fieldName}
                    size={size}
                    onCheckedChange={onChange}
                  />
                  <InnerLabel tag="div">{label}</InnerLabel>
                </Label>
              ) : (
                <Toggle
                  checked={isChecked}
                  disabled={disabled}
                  name={fieldName}
                  size={size}
                  onCheckedChange={onChange}
                />
              )}
            </Flex>
          );
        }}
      />
    </FormFieldWrapper>
  );
};
